/**
 * The file lines a message carries, shared by the chat bubble and the email
 * block (SA-1127): an attachment row with its meta read once (SA-1094), and
 * one line per file that was not loaded (SA-715, SA-979).
 */
import { FileX } from 'lucide-react'
import type { InboxMessage, InboxMissingFile } from '@/types/inbox'
import { MediaAttachment } from './MediaAttachment'
import { attachmentMeta } from './mediaGallery'
import type { ViewerSet } from './MediaViewerDialog'

/** One attachment row under a body: a file's `MediaAttachment` with its meta read once. */
export function AttachmentRow({ file, viewer }: { file: InboxMessage; viewer?: ViewerSet }) {
  const { filename, byteSize, mimeType } = attachmentMeta(file)
  return (
    <MediaAttachment
      messageId={file.id}
      mediaType={file.mediaType ?? 'document'}
      mediaUrl={file.mediaUrl ?? ''}
      filename={filename}
      byteSize={byteSize}
      mimeType={mimeType}
      viewer={viewer}
    />
  )
}

export function MissingFileLines({ missing }: { missing: readonly InboxMissingFile[] }) {
  return (
    <>
      {missing.map((file, index) => (
        <p key={`${file.providerMessageId}:${index}`} className="text-xs text-muted-foreground italic mb-1 flex items-center gap-1">
          <FileX className="w-3 h-3 shrink-0" aria-hidden="true" />
          {/* A long file name wraps here rather than widening the message. */}
          <span className="min-w-0 [overflow-wrap:anywhere]">File not loaded: {file.filename} ({file.reason})</span>
        </p>
      ))}
    </>
  )
}
